<template>
    <section id="add-attachments-hos-pal" class="px-2 px-lg-5 py-2 rounded-lg border shadow mb-1">
        <h6>Add Attachment</h6>
        <FormSection :full-height="false" :show-product-pill="false" :application-id="visitDetails.Application">
            <template #content>
                <div class="py-4 d-flex flex-column gap-3">
                    <div class="row">
                        <div class="form-group col-12 col-md-4 offset-md-2">
                            <label> File <span class="text-danger">*</span> </label>
                            <div class="upload-document" v-if="!fileDetails && !uploading">
                                <button type="button" class="btn btn-primary border border-primary">
                                    Choose File

                                    <input type="file" @change="uploadFilesChanged($event)" class="file-input" />
                                </button>
                                <div
                                    class="invalid-feedback d-block"
                                    id="validation-feedback-1"
                                    v-if="fileUploadErrorMessage"
                                >
                                    {{ fileUploadErrorMessage }}
                                </div>
                            </div>
                            <div class="input-border p-2 bg-white" v-else>
                                <div class="d-flex align-items-center" v-if="uploading">
                                    <i
                                        class="fas fa-file text-primary animated flash infinite slower font-size-md blinking-content"
                                    ></i>
                                    <span class="text-primary ms-2">Loading File...</span>
                                </div>
                                <div class="d-flex align-items-center" v-else>
                                    <i
                                        class="au-target file-icon far fa-file fa-file-image font-size-md me-1"
                                        au-target-id="1814"
                                    ></i>
                                    <!--anchor-->
                                    <a class="au-target" href="javascript:void(0);">{{ fileDetails.name }}</a>
                                    <button
                                        type="button"
                                        class="btn table-btn btn-outline-danger ml-auto au-target"
                                        @click="removeAllFiles()"
                                        :disabled="isSaving"
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12 col-md-4 is-invalid">
                            <label> Document Type <span class="text-danger">*</span> </label>
                            <TypeaheadInput
                                placeholder="Start Typing..."
                                :data="searchedTypes"
                                :value="selectedUploadType"
                                v-on:valueChanged="(newValue: any) => updateTypeId(newValue.value)"
                                v-on:blurredInput="v$.fileDetails.uploadTypeId.$touch()"
                                :disabled="uploading || isSaving"
                                :showAllByDefault="true"
                                :openOnFocus="true"
                            ></TypeaheadInput>
                            <div
                                class="invalid-feedback d-block"
                                id="validation-feedback-2"
                                v-if="v$.fileDetails.uploadTypeId.$error"
                            >
                                Document Type is required.
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </FormSection>
        <div class="d-flex justify-content-center mt-2 p-2" v-if="!isLoading">
            <span v-if="isSaving">
                <button class="btn btn-primary">
                    <i class="fa fa-spinner fa-spin animated slow flash infinite"></i>
                </button>
            </span>
            <span v-else>
                <button class="btn btn-primary" @click="saveAttachment()">Save Attachment</button>
                <button type="button" class="ms-1 btn btn-md btn-outline-secondary" @click="toggleUploadFile()">
                    Cancel
                </button>
            </span>
        </div>
    </section>
</template>

<script lang="ts" src="./AddAttachmentsFormHosPal.ts" />
<style lang="scss" src="./AddAttachmentsFormHosPal.scss"></style>
